export default {
  twitter: '#1DA1F2',
  twitter_dark_hover: 'rgba(29, 161, 242, .1)',
  twitter_light_hover: '#1a91da',
}